import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { compareByKey } from "../../utils/sorting";
import SourcedFrom from "../common/SourcedFrom";

export default () => {
  const [activeTab, setActiveTab] = useState("red");
  const data = useStaticQuery(graphql`
    query JewelQuery {
      allJewelStatsCsv {
        nodes {
          A
          B
          C
          S
          SS
          SSS
          color
          stat
        }
      }
      allJewelBonusCsv {
        nodes {
          rank
          blue
          green
          purple
          red
          yellow
        }
      }
    }
  `);

  function switchTab(order) {
    setActiveTab(order);
  }

  const jewelStatNodes = data.allJewelStatsCsv.nodes;
  const jewelBonusNodes = data.allJewelBonusCsv.nodes;
  return (
    <div>
      <SourcedFrom />
      <h4 className="title">Jewel Table</h4>
      <div className="tabs is-fullwidth">
        <ul>
          <li
            className={`${activeTab === "red" ? "is-active" : ""}`}
            onClick={() => switchTab("red")}
          >
            <a>Red</a>
          </li>
          <li
            className={`${activeTab === "blue" ? "is-active" : ""}`}
            onClick={() => switchTab("blue")}
          >
            <a>Blue</a>
          </li>
          <li
            className={`${activeTab === "green" ? "is-active" : ""}`}
            onClick={() => switchTab("green")}
          >
            <a>Green</a>
          </li>
          <li
            className={`${activeTab === "yellow" ? "is-active" : ""}`}
            onClick={() => switchTab("yellow")}
          >
            <a>Yellow</a>
          </li>
          <li
            className={`${activeTab === "purple" ? "is-active" : ""}`}
            onClick={() => switchTab("purple")}
          >
            <a>Purple</a>
          </li>
        </ul>
      </div>
      <div className="table-container">
        <Table className="table is-hoverable">
          <Thead>
            <Tr>
              <Th>Stat</Th>
              <Th>C</Th>
              <Th>B</Th>
              <Th>A</Th>
              <Th>S</Th>
              <Th>SS</Th>
              <Th>SSS</Th>
            </Tr>
          </Thead>
          <Tbody>
            {jewelStatNodes
              .sort((a, b) => compareByKey(a, b, "color"))
              .map((node, index) => {
                if (node.color !== activeTab) return;
                const percent = node.stat.includes("%") ? "%" : "";
                return (
                  <Tr key={index}>
                    <Td>{node.stat}</Td>
                    <Td>
                      {node.C}
                      {percent}
                    </Td>
                    <Td>
                      {node.B}
                      {percent}
                    </Td>
                    <Td>
                      {node.A}
                      {percent}
                    </Td>
                    <Td>
                      {node.S}
                      {percent}
                    </Td>
                    <Td>
                      {node.SS}
                      {percent}
                    </Td>
                    <Td>
                      {node.SSS}
                      {percent}
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </div>
      <h4 className="title is-4">Set Bonuses</h4>
      <h5 className="subtitle is-6">(5 jewels of the same color & rank)</h5>
      <div className="table-container">
        <Table className="table is-bordered is-hoverable">
          <Thead>
            <Tr>
              <Th>Rank</Th>
              <Th>Blue</Th>
              <Th>Green</Th>
              <Th>Red</Th>
              <Th>Purple</Th>
              <Th>Yellow</Th>
            </Tr>
          </Thead>
          <Tbody>
            {jewelBonusNodes.sort().map((node, index) => {
              return (
                <Tr key={index}>
                  <Td>{node.rank}</Td>
                  <Td>{node.blue}</Td>
                  <Td>{node.green}</Td>
                  <Td>{node.red}</Td>
                  <Td>{node.purple}</Td>
                  <Td>{node.yellow}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </div>
    </div>
  );
};
